import * as React from "react";
import { useTranslation } from "react-i18next";
import { IContainerPoint } from "../interfaces/IContainerPoint";
import { wrapperStyles } from "../styles/style";
import { ContainerBatteryStatusEnumToString } from "../../common/converters/containerBatteryStatus";

export interface ContainerPopupHtmlProps {
    containnerData: IContainerPoint;
}

const COPY_ICON = "<svg xmlns='http://www.w3.org/2000/svg' width='13' height='13' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'><rect x='9' y='9' width='13' height='13' rx='2' ry='2'></rect><path d='M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1'></path></svg>";
const COPY_BTN_STYLE = "cursor:pointer;background:none;border:none;padding:2px 4px;vertical-align:middle;color:#666;line-height:1;";

function escapeAttribute(value: string): string {
    return value
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
}

function copyBtn(value: string, title: string): string {
    return ' <button data-v="' + escapeAttribute(value) + '" onclick="window.__copyText(this)" style="' + COPY_BTN_STYLE + '" title="' + escapeAttribute(title) + '">' + COPY_ICON + '</button>';
}

export const ContainerPopupHtml: React.FC<ContainerPopupHtmlProps> = ({ containnerData }) => {
    const { t } = useTranslation("admin");
    return (
        <div style={wrapperStyles.popupStyles}>
            <div>
                {t("storeMap.popup.containerNumber")} <b>{containnerData.containerNumber != null ? containnerData.containerNumber : t("storeMap.popup.noNumber")}</b>
                {containnerData.containerNumber != null
                    ? <span dangerouslySetInnerHTML={{ __html: copyBtn(String(containnerData.containerNumber), t("storeMap.popup.copy")) }} />
                    : null}
            </div>
            {containnerData.serNo !== undefined ? <div>
                {t("storeMap.popup.serialNumber")} <b>{containnerData.serNo}</b>
                <span dangerouslySetInnerHTML={{ __html: copyBtn(String(containnerData.serNo), t("storeMap.popup.copy")) }} />
            </div> : null}
            {t("storeMap.popup.lastReading")} {containnerData.lastActiveDate}< br />
            {(containnerData.imei !== undefined && containnerData.imei !== 0) ? <>{t("storeMap.popup.imei")} {containnerData.imei} < br /> </> : <></>}
            {containnerData.iccid !== undefined ? <>{t("storeMap.popup.iccid")} {containnerData.iccid} < br /> </> : <></>}
            {containnerData.currentBatteryLevel !== undefined ? <>{t("storeMap.popup.batteryLevel")} {containnerData.currentBatteryLevel} {t("storeMap.popup.voltUnit")}<br /> </> : <></>}
            {containnerData.currentBatteryStatus !== undefined ? <>{t("storeMap.popup.batteryStatus")} {ContainerBatteryStatusEnumToString(containnerData.currentBatteryStatus)}<br /> </> : <></>}
            <div style={wrapperStyles.historyLinkWrapper}
                dangerouslySetInnerHTML={{ __html: '<span onclick="window.__openContainerHistory()" style="cursor:pointer;color:#0078d4;text-decoration:underline;">' + escapeAttribute(t("storeMap.popup.locationHistory")) + '</span>' }}
            />
        </div>
    )
}
